import type { FormControl } from '@angular/forms';
import type { UpgradeType } from '@freelancer/components/upgrade-tag';
import type {
  Currency,
  MilestoneRequest,
} from '@freelancer/datastore/collections';
import type { ProjectUpgradeOptionsApi } from 'api-typings/projects/projects';

export const MINIMUM_MILESTONE_AMOUNT = 1;
export const DEFAULT_REQUEST_ID = 0;

export interface FormValues {
  milestoneRequest: MilestoneRequest;
  checkboxControl: boolean;
  amountControl: string;
}

export interface UpgradeListElement {
  readonly type: UpgradeType;
  readonly control: FormControl<boolean>;
  readonly currency: Currency;
  readonly fee: number;
}

export interface UpgradeItem {
  readonly type: ProjectUpgradeOptionsApi;
  readonly amount: number;
}

export interface UpgradeFormItems {
  readonly [k: string]: boolean;
}

export type UpgradesFees = {
  readonly [k in ProjectUpgradeOptionsApi]?: number;
};

export interface MilestoneRequestWithAmount extends MilestoneRequest {
  amount: number;
}

export interface RequestPair {
  approvedRequest: MilestoneRequestWithAmount;
  request: MilestoneRequestWithAmount;
}

export interface MilestoneRequestWithAmount extends MilestoneRequest {
  amount: number;
}

export interface RequestPair {
  approvedRequest: MilestoneRequestWithAmount;
  request: MilestoneRequestWithAmount;
}

export interface AwardModalUpgradesFormGroupType {
  nda: FormControl<boolean>;
  ip: FormControl<boolean>;
  private: FormControl<boolean>;
  fulltime: FormControl<boolean>;
}
